










import Vue from "vue";
import Translator from "@/components/Translator.ts";
import axios from "axios";

export default Vue.extend({
  name: "Translate",
  data() {
    return {
      site: "https://en.wikipedia.org/wiki/Corn_dog",
      data: "<center style='margin-top: 100px'>Loading page...</center>"
    };
  },
  created() {
    this.loadPage();
  },
  computed: {
    uriSafeUrl(): string {
      return encodeURI(this.site);
    }
  },
  methods: {
    async loadPage() {
      try {
        const { data: response } = await axios.get(
          `https://us-central1-lerngwerge.cloudfunctions.net/translate/asdf?url=${
            this.uriSafeUrl
          }`
        );
        this.data = response;
      } catch (e) {
        console.log(e);
        this.data = `<center style="margin-top: 100px"> Error: ${
          e.message
        }</center>`;
      }
    }
  }
});
